"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearObject = void 0;
exports.difference = difference;
exports.mergeEntities = exports.isObject = void 0;
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _map = _interopRequireDefault(require("lodash/map"));
var _mergeWith = _interopRequireDefault(require("lodash/mergeWith"));
var _transform = _interopRequireDefault(require("lodash/transform"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var customMerge = (a, b) => (0, _isArray.default)(b) ? b : undefined;
var clearObject = obj => {
  if (!(0, _isObject.default)(obj)) return obj;

  // remove all useless values in order to optimize the size of this object.
  // false, null, undefined will be removed

  if ((0, _isArray.default)(obj)) {
    return obj.filter(value => !!value || value === 0);
  } else {
    var lightObj = _objectSpread({}, obj);
    (0, _map.default)(obj, (value, param) => {
      if (!value && value !== 0) delete lightObj[param];
    });
    return lightObj;
  }
};

/**
 * Deep diff between two object, using lodash (only used for debugging)
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
exports.clearObject = clearObject;
function difference(object, base) {
  function changes(object, base) {
    return (0, _transform.default)(object, function (result, value, key) {
      if (!(0, _fastDeepEqual.default)(value, base[key])) {
        result[key] = (0, _isObject.default)(value) && (0, _isObject.default)(base[key]) ? changes(value, base[key]) : value;
      }
    });
  }
  return changes(object, base);
}
var isObject = obj => !!obj && typeof obj === 'object' && obj.length === undefined;
exports.isObject = isObject;
var mergeEntities = (state, entitiesToMerge) => {
  if (!isObject(state)) {
    throw new Error('Missing state');
  }
  if (!isObject(entitiesToMerge)) {
    throw new Error('Missing entities');
  }
  var keysToMerge = Object.keys(entitiesToMerge);
  if (keysToMerge.length === 0) return state;
  var newState = (0, _cloneDeep.default)(state);
  return (0, _mergeWith.default)(newState, entitiesToMerge, customMerge);
};
exports.mergeEntities = mergeEntities;